import { useMemo } from "react";

import { useAARData } from "../../context/AARDataContext";

import "./SearchFilters.css";

function SearchFilters({
  searchTerm,
  setSearchTerm,

  year,
  setYear,

  type,
  setType,

  area,
  setArea,

  status,
  setStatus,

  onClear,
}) {
  const { projects } = useAARData();

  const filterOptions = useMemo(() => ({
    years: [...new Set(projects.map((project) => String(project.year || "")).filter(Boolean))].sort().reverse(),
    types: [...new Set(projects.map((project) => project.type).filter(Boolean))].sort(),
    areas: [...new Set(projects.map((project) => project.area).filter(Boolean))].sort(),
    statuses: [...new Set(projects.map((project) => project.status).filter(Boolean))].sort(),
  }), [projects]);

  const hasActiveFilters = Boolean(
    searchTerm || year || type || area || status
  );

  return (
    <section className="search-section">
      <div className="search-container">

        {/* SEARCH */}
        <div className="search-box">
          <span className="search-icon">
            🔍
          </span>

          <input
            type="text"
            placeholder="Search AAR projects..."
            value={searchTerm}
            onChange={(event) =>
              setSearchTerm(event.target.value)
            }
          />
        </div>


        {/* YEAR */}
        <select
          value={year}
          onChange={(event) =>
            setYear(event.target.value)
          }
        >
          <option value="">
            All Years
          </option>

          {filterOptions.years.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>


        {/* TYPE */}
        <select
          value={type}
          onChange={(event) =>
            setType(event.target.value)
          }
        >
          <option value="">
            All Types
          </option>

          {filterOptions.types.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>


        {/* AREA */}
        <select
          value={area}
          onChange={(event) =>
            setArea(event.target.value)
          }
        >
          <option value="">
            All Areas
          </option>

          {filterOptions.areas.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>


        {/* STATUS */}
        <select
          value={status}
          onChange={(event) =>
            setStatus(event.target.value)
          }
        >
          <option value="">
            All Statuses
          </option>

          {filterOptions.statuses.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>

        <button
          type="button"
          className="clear-filters-button"
          onClick={onClear}
          disabled={!hasActiveFilters}
        >
          Clear filters
        </button>

      </div>
    </section>
  );
}

export default SearchFilters;